import { IgDialog } from "@intelligems/ig-theme/IgDialog";

import { GateChip } from "@src/components/PricingGatedModal/GateChip";

interface ModuleTrialEndingDialogViewProps {
  isOpen: boolean;
  countdownLabel: string;
  moduleDisplayName: string;
  onClose: () => void;
  onViewPlans: () => void;
  onAddToPlan: () => void;
}

export function ModuleTrialEndingDialogView({
  isOpen,
  countdownLabel,
  moduleDisplayName,
  onClose,
  onViewPlans,
  onAddToPlan,
}: ModuleTrialEndingDialogViewProps) {
  return (
    <IgDialog
      showDialog={isOpen}
      handleClose={onClose}
      handleNoClick={onViewPlans}
      handleYesClick={onAddToPlan}
      showCloseIcon={true}
      shouldNotClose={true}
      fullWidth={true}
      maxWidth="sm"
      dialogHeight={null}
      dialogContentWidth="100%"
      dialogImage={
        <GateChip label={countdownLabel} tone="warning" sx={{ mb: 2 }} />
      }
      title={`Keep ${moduleDisplayName} running`}
      subtitle="Keep your live experiences active by upgrading now."
      noButtonText="View all plans"
      yesButtonText="Add to plan"
    />
  );
}
